/**
 * Spinner — the one animated loading element (design-system-lld.md §4.10).
 */
import * as React from 'react';
import { Loader2 } from 'lucide-react';
import { cn } from '@/lib/utils';

export type SpinnerSize = 'sm' | 'md';

const SIZE_CLASSES: Record<SpinnerSize, string> = {
  sm: 'h-4 w-4',
  md: 'h-6 w-6',
};

export interface SpinnerProps extends React.HTMLAttributes<HTMLSpanElement> {
  size?: SpinnerSize;
}

export function Spinner({ size = 'md', className, ...props }: SpinnerProps) {
  return (
    <span role="status" className={cn('inline-flex', className)} {...props}>
      <Loader2 className={cn('animate-spin text-gray-400', SIZE_CLASSES[size])} aria-hidden="true" />
      <span className="sr-only">Loading</span>
    </span>
  );
}
